// TODO remove this theme when https://github.com/Liscio-Inc/liscio-frontend/pull/1437 is merged
import { blue } from '@mui/material/colors';

import { createTheme, ThemeExtension } from '@liscio/ui';

const nTheme: ThemeExtension = (theme) => ({
  palette: {
    background: {
      default: '#f7f8f8',
    },
    action: {
      hover: blue[50],
    },
    primary: {
      main: '#0061a0', // Override primary color
    },
  },
  typography: {
    h4: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.24,
      letterSpacing: '0.25px',
    },
    h5: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: '1.5rem',
      fontWeight: 400, // normal
      lineHeight: 1.33,
      letterSpacing: 'normal',
    },
    h6: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: '1.25rem',
      fontWeight: 400, // normal
      lineHeight: 1.6,
      letterSpacing: '0.15px',
      [theme.breakpoints.up('md')]: {
        fontSize: '1.25rem',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '1.25rem',
      },
    },
    body1: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: '1rem',
      fontWeight: 400, // normal
      lineHeight: 1.5,
      letterSpacing: '0.15px',
      [theme.breakpoints.up('md')]: {
        fontSize: '1rem',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '1rem',
      },
    },
    body2: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: '0.875rem',
      fontWeight: 400, // normal
      lineHeight: 1.43,
      letterSpacing: '0.17px',
      [theme.breakpoints.up('md')]: {
        fontSize: '0.875rem',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '0.875rem',
      },
    },
    subtitle1: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.75,
      letterSpacing: '0.15px',
    },
    caption: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: '0.875rem',
      lineHeight: '0.875rem',
      letterSpacing: '0.15px',
    },
  },
});

export const theme = createTheme({
  extensions: [nTheme],
});
